<template>
    <div class="user">
        <Modal
            v-model="showDelModal"
            :title="$t('confirm')+$t('lock')"
            @on-ok="showDelModal=false;lockUser(userIdToDel);"
            @on-cancel="showDelModal=false"
        >
            <p>{{$t('confirmDel')}}</p>
        </Modal>

        <div class="search">
            <Input v-model="search" :placeholder="$t('searchTips')+'...'" style="width:200px;"></Input>
            <Button type="primary" @click="loadData(currentPage)">{{$t('searchText')}}</Button>
            <Button type="primary" class="add_user" icon="md-add" @click="show_add_user = true">{{$t('add')}}{{$t('user')}}</Button>
        </div>
        <Table border :columns="columns12" :data="data6">
        </Table>
        <div class="page">
            <Page
                :total="totalItems"
                :page-size="itemsPerPage"
                show-elevator
                :current="currentPage"
                @on-change="loadData"
            />
        </div>
        <Modal v-model="show_edit_modal" :title="$t('edit')" @on-ok="edit_modal_ok">
            <Form :model="modalEdit" :label-width="100">
                <FormItem :label="$t('rate')">
                    <Input type="number" v-model="modalEdit.rate" min="0" max="100" step="0.01"></Input>
                </FormItem>
                <FormItem :label="$t('min')">
                    <Input type="number" v-model="modalEdit.min" min="0"></Input>
                </FormItem>
                <FormItem :label="$t('min_kyc')">
                    <Input type="number" v-model="modalEdit.min_kyc" min="0"></Input>
                </FormItem>
                <FormItem :label="$t('required_kyc')">
                    <Input type="number" v-model="modalEdit.required_kyc" min="0" step="0.01"></Input>
                </FormItem>
            </Form>
        </Modal>
        <Modal v-model="showImageModal" :title="$t('image')" @on-ok="showImageModal = false">
            <img :src="imageUrl" style="width: 100%; height: 100%;">
        </Modal>
    </div>
</template>


<script>
import { formatUTCTime as formatUTC } from '../../common/common.js';

export default {
    data() {
        return {
            showDelModal: false,
            userIdToDel: 0,
            currentPage: 1,
            totalItems: 0,
            totalPages: 1,
            totalItems: 1,
            itemsPerPage: 10,
            search: "",
            showImageModal: false,
            imageUrl: '',
            modalUpdateCredit: {
                user_id: 0,
                credit_score: 0
            },
            columns12: [
                {
                    title: "ID",
                    key: "user_id"
                },
                {
                    title: this.$i18n.t('username'),
                    key: "username"
                },
                {
                    title: 'Email',
                    width: 150,
                    key: "email",
                },
                {
                    title: this.$i18n.t('mobile'),
                    width: 120,
                    key: "mobile"
                },
                {
                    title:'CCDKYC',
                    key: "id_card_front_img,id_card_back_img",
                    render: (h, params) => {
                        return h('div',{style: {display: 'flex', alignItems: 'center'}}, [
                        h('img', 
                        {
                        attrs: {src: params.row.id_card_front_img}, 
                        style: {width: '100px', height: '100px',cursor: 'pointer'},
                        on: {
                            click: () => {
                                this.showImage(params.row.id_card_front_img);
                            }
                        }
                    }), 
                        h('img', {
                        attrs: {src: params.row.id_card_back_img}, 
                        style: {width: '100px', height: '100px',cursor: 'pointer'},
                        on: {
                            click: () => {
                                this.showImage(params.row.id_card_back_img);
                            }
                        }
                    })
                    ]);
                    }
                },
                   
                {
                    title: this.$i18n.t('user_charge_address'),
                    key: "user_charge_address",
                },
                {
                    title: this.$i18n.t('user_rate'),
                    key: "rate",
                },
                {
                    title: this.$i18n.t('min'),
                    key: "min",
                },
                {
                    title: this.$i18n.t('min_kyc'),
                    key: "min_kyc",
                },
                {
                    title: this.$i18n.t('required_kyc'),
                    key: "required_kyc",
                },
                {
                    title: this.$i18n.t('is_verified'),
                    key: "is_verified",
                    render: (h, params) => {
                        return h("Icon", {
                            props: {
                                type: params.row.is_verified == 1 ? 'md-close' : 'md-checkmark',
                                size: 20,
                                color: 'white'
                            },
                            style: {
                                backgroundColor: params.row.is_verified == 1 ? 'red' : 'green',
                                border: 'none',
                               
                            },
                            on: {
                                click: () => {
                                    this.edit_is_verified(params.row.user_id, params.row.is_verified)
                                    }
                                }
                            }, params.row.is_verified == 1 ? this.$i18n.t('reject'):this.$i18n.t('pass'));
                    }
                },
                {
                    title: this.$i18n.t('edit'),
                    key: "edit",
                    
                    render: (h, params) => {
                        return h('Icon',{
                            props: {
                                type: 'md-create',
                                size: 20,
                                color: 'white'
                            },
                            style: {
                                backgroundColor: 'blue',
                                border: 'none',
                            },
                            on: {
                                click: () => {
                                    this.edit_modal(params.row)
                                }
                            }
                        }, this.$i18n.t('edit'));
                    }
                }
            ],
            data6: [],
            modalEdit:{
                user_id:'',
                rate:'',
                min:'',
                min_kyc:'',
                required_kyc:''
            },

            show_edit_modal:false
        };
    },
    mounted() {
        this.loadData(1);
    },
    methods: {
        loadData(page) {
            this.currentPage = page;
            let path = this.search ? this.$path.user_search : this.$path.user;
            this.$get(path, {
                mobile: this.search,
                page: this.currentPage,
                type: "kyc"
            }).then(res => {
                if (res.data) {
                    this.data6 = res.data.list;
                    this.totalItems = res.data.pageObj.totalSize;
                    this.itemsPerPage = res.data.pageObj.pageSize;
                } else {
                    this.$Message.error(this.$i18n.t('dataFailed'));
                }
            });
        },
        edit_modal(row) {
            this.modalEdit.user_id = row.user_id;
            this.modalEdit.rate = row.rate;
            this.modalEdit.min = row.min;
            this.modalEdit.min_kyc = row.min_kyc;
            this.modalEdit.required_kyc = row.required_kyc;
            this.show_edit_modal = true;
        },
        edit_modal_ok() {
            this.$post(this.$path.user_edit, this.modalEdit).then(res => {
                if (res.success) {
                    this.$Message.success(this.$i18n.t('operateSuccess'));
                    this.loadData(this.currentPage);
                    this.show_edit_modal = false;
                }
                else {
                    this.$Message.error(this.$i18n.t('operateFailed'));
                }
            });
        },
        edit_is_verified(id, is_verified) {
            this.$post(this.$path.user_edit, {
                user_id: id,
                is_verified: is_verified == 1 ? 0 : 1
            }).then(res => {
                if (res.success) {
                    this.$Message.success(this.$i18n.t('operateSuccess'));
                    this.loadData(this.currentPage);
                }
                else {
                    this.$Message.error(this.$i18n.t('operateFailed'));
                }
            });
        },
        formatUTCTime(utcTimeString) {
            return formatUTC(utcTimeString, 8); // 使用东八区
        },
        showImage(imageUrl) {
            this.imageUrl = imageUrl;
            this.showImageModal = true;
        }
    }
};
</script>


<style lang="scss" scoped>
.search {
    margin-bottom: 20px;
    .add_user {
        float: right;
    }
}
.page {
    margin-top: 20px;
    display: flex;
    justify-content: center;
}
</style>



// WEBPACK FOOTER //
// src/components/user/wallet_kyc.vue